module.exports = __webpack_public_path__ + "img/predict.154427cb.png";